<template>
    <div>
        <KpFieldlabel :label="label" :disabled="disabled" :info-text="infoText" />
        <v-textarea
            :disabled="disabled"
            class="inputfield"
            v-bind="$attrs"
            v-model:model-value="modelValue"
        >
        </v-textarea>
    </div>
</template>

<script setup lang="ts">
import KpFieldlabel from './kp-fieldlabel.vue';

const modelValue = defineModel<string | null>({ default: null })

const {
    label = '',
    infoText = null,
    disabled = false,
} = defineProps<{
    label: string
    infoText?: string | null
    disabled?: boolean
}>()
</script>

<style lang="css" scoped>
.inputfield {
    margin-left: -1rem;
}
.icon-margin {
    margin-left: 0.25rem;
}
</style>
